import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@shared-models';
import { API_CONFIG, ApiConfig } from './api-config';

export interface GuestTokenResponse {
  token: string;
}

/**
 * Obtiene un guest token desde el backend.
 * URL = `{apiUrl}{guestTokenEndpoint}` (ej. `/api/guest/token`).
 */
@Injectable({ providedIn: 'root' })
export class GuestService {
  private readonly http = inject(HttpClient);
  private readonly apiConfig = inject<ApiConfig>(API_CONFIG);

  getGuestToken(): Observable<ApiResponse<GuestTokenResponse>> {
    const endpoint = this.apiConfig.guestTokenEndpoint.startsWith('/')
      ? this.apiConfig.guestTokenEndpoint
      : `/${this.apiConfig.guestTokenEndpoint}`;

    return this.http.post<ApiResponse<GuestTokenResponse>>(
      `${this.apiConfig.apiUrl}${endpoint}`,
      {},
    );
  }
}
